var React = require('react');

function Search (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M23.6597 33.4289L16.8905 26.6597L17.0956 26.4546C20.3776 22.2494 19.5571 16.1981 15.4546 13.0187C13.4033 11.4802 10.9417 10.7622 8.37763 11.0699C5.81353 11.3776 3.55712 12.6084 2.01866 14.6597C0.480196 16.711 -0.237753 19.1725 0.0699391 21.7366C0.377631 24.3007 1.71096 26.5571 3.65968 28.0956C5.30071 29.4289 7.45455 30.1469 9.50584 30.1469C11.6597 30.1469 13.711 29.4289 15.352 28.0956L15.5571 27.8905L22.3263 34.6597C22.7366 34.9674 23.2494 34.9674 23.6597 34.6597C24.0699 34.352 24.0699 33.7366 23.6597 33.4289ZM9.6084 28.4033C5.30071 28.4033 1.81353 24.9161 1.81353 20.6084C1.81353 16.3007 5.30071 12.8135 9.6084 12.8135C13.9161 12.8135 17.4033 16.3007 17.4033 20.6084C17.4033 24.9161 13.9161 28.4033 9.6084 28.4033Z","fill":"#262626"}));
}

Search.defaultProps = {"width":"24","height":"45","viewBox":"0 0 24 45","fill":"none"};

module.exports = Search;

Search.default = Search;
